import { render, staticRenderFns } from "./tbmFulfillment.vue?vue&type=template&id=01df51a7"
import script from "./tbmFulfillment.vue?vue&type=script&lang=js"
export * from "./tbmFulfillment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01df51a7')) {
      api.createRecord('01df51a7', component.options)
    } else {
      api.reload('01df51a7', component.options)
    }
    module.hot.accept("./tbmFulfillment.vue?vue&type=template&id=01df51a7", function () {
      api.rerender('01df51a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/tbm/tbmFulfillment.vue"
export default component.exports